@if (!minimized) {
  <div class="panel">
    <div class="border-b border-gray-200">
      <div class="px-8 h-20 items-center flex gap-3">
        <div class="text-[13px] font-medium tracking-[0.3px] text-headline whitespace-nowrap overflow-hidden text-ellipsis">
          {{ sidebarFilter | titleBySheetsFilter: containerName }}
          @if (isAdvancedSearchApplied()) {
            – Search Results
          }
        </div>
        <div class="grow"></div>
        <!-- [MUST-003] 'Debug' button hidden per task; uncomment to re-enable
        <div
          class="debug"
          [class.active]="debug"
          (click)="doDebug()"
          >
          {{ debug || 'Debug' }}
        </div>
        -->
        @if (selectedTab === 'sheets') {
          <app-context-menu-state-indicator
            svgIcon="filters"
            appSheetsListContextMenu
            [appSheetsListContextMenuWithAdvancedSearch]="true"
            />
        }
        @if (selectedTab === 'sheetFolders') {
          <app-context-menu-state-indicator
            svgIcon="filters"
            appSheetFoldersListContextMenu
            [appSheetFoldersListContextMenuWithAdvancedSearch]="true"
            />
        }
      </div>
      @if (listState === 'tabs') {
        <app-tabs
          class="panel-heading-tabs"
          [values]="tabs"
          [(value)]="selectedTab"
          />
      }
    </div>
        <div class="panel-list">
          @if (selectedTab === 'sheets') {
            <app-sheets-list
              [filters]="sheetsFilters"
              [debug]="debug"
              [showLocationBadge]="isAdvancedSearchApplied()"
              [besideEditor]="inEditor"
              (loadInProgress)="loading = $event"
              (openSheet)="handleOpenSheet($event)"
              (clickSheet)="handleClickSheet($event)"
              (doubleClickSheet)="handleDoubleClickSheet($event)"
              />
          }
          @if (selectedTab === 'sheetFolders') {
            <app-sheet-folders-list
              [filters]="sheetFoldersFilters"
              [debug]="debug"
              (loadInProgress)="loading = $event"
              (openSheetFolder)="handleClickSheetFolder($event)"
              (openSheet)="handleClickSheet($event)"
              (clickSheetFolder)="handleClickSheetFolder($event)"
              (doubleClickSheetFolder)="handleDoubleClickSheetFolder($event)"
              />
          }
        </div>
      </div>
    }
